/* Dear Nikola product page: small behaviours, no dependencies. Loaded only on the dn product template. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- money, no trailing zeros ---------- */
  function money(cents, format) {
    var amount = cents / 100;
    var txt = Number.isInteger(amount) ? String(amount) : amount.toFixed(2);
    if (/comma_separator/.test(format || '')) txt = txt.replace('.', ',');
    return (format || '${{amount}}').replace(/\{\{\s*\w+\s*\}\}/, txt);
  }

  /* ---------- add to cart (set panel) ---------- */
  function drawer() { return document.querySelector('cart-drawer'); }

  function addItems(items, btn) {
    var cd = drawer();
    var body = { items: items };
    if (cd && typeof cd.getSectionsToRender === 'function') {
      body.sections = cd.getSectionsToRender().map(function (s) { return s.id; }).join(',');
      body.sections_url = window.location.pathname;
    }
    if (btn) btn.classList.add('is-busy');
    return fetch(((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok || res.j.status) throw new Error(res.j.description || 'add failed');
        if (cd && typeof cd.renderContents === 'function') {
          /* the drawer keeps its is-empty class until the theme's own add clears it; Shrine's open() reads it to pick what to focus */
          cd.classList.remove('is-empty');
          cd.renderContents(res.j, false);
        } else {
          window.location.href = '/cart';
        }
      })
      .catch(function (e) {
        if (btn) { btn.setAttribute('data-error', '1'); setTimeout(function () { btn.removeAttribute('data-error'); }, 2500); }
        if (window.console) console.warn('[dn-pdp] add failed', e);
      })
      .then(function () { if (btn) btn.classList.remove('is-busy'); });
  }

  document.addEventListener('click', function (e) {
    var one = e.target.closest('[data-dnp-add]');
    if (one) {
      e.preventDefault();
      addItems([{ id: Number(one.getAttribute('data-dnp-add')), quantity: 1 }], one);
      return;
    }
    var all = e.target.closest('[data-dnp-add-all]');
    if (all) {
      e.preventDefault();
      var items = [];
      document.querySelectorAll('[data-dnp-look]:checked').forEach(function (b) { items.push({ id: Number(b.getAttribute('data-dnp-look')), quantity: 1 }); });
      if (!items.length || all.classList.contains('is-busy')) return;
      /* 10-07 (via 100-da): the prices and pills in the box assume this page's own product is in the cart (it takes part in Buy 2 / Buy 3),
         so Add all adds it too, unless that exact variant is already in the cart. No size/colour picked yet: take him to the picker instead. */
      var page = pageItem(document.querySelector('[data-dnp-look-part]'));
      if (page && page.gap) { chooseVariant(page); return; }
      if (!page || !page.id) { addItems(items, all); return; }
      all.classList.add('is-busy');
      fetch(((window.routes && window.routes.cart_url) || '/cart') + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { return (c.items || []).some(function (l) { return l.variant_id === page.id; }); })
        .catch(function () { return false; })
        .then(function (inCart) {
          if (!inCart) items.unshift({ id: page.id, quantity: 1 });
          return addItems(items, all);
        });
      return;
    }
    /* 10-06: the small "Size guide" link beside the Size option opens the Size and fit panel and scrolls to it */
    var sg = e.target.closest('[data-dnp-sizeguide]');
    if (sg) {
      var panel = document.getElementById('dnp-size-fit');
      if (panel) {
        e.preventDefault();
        panel.classList.remove('closing');
        panel.open = true;
        panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      return;
    }
    /* clips play inside their own tile (10-06d), see "community clips" below */
  });

  /* ---------- this page's own product (10-07, via 100-da) ---------- */
  function mainForm() {
    var fs = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < fs.length; i++) {
      if (!fs[i].closest('cart-drawer') && !fs[i].classList.contains('installment') && fs[i].querySelector('[name="id"]')) return fs[i];
    }
    return null;
  }
  function optionWord(name) { return String(name || '').replace(/^options\[(.*)\]$/, '$1').replace(/[-_]?\d+$/, '').trim().toLowerCase().replace(/^colour$/, 'color'); }
  /* the first option group (size, colour...) with nothing picked, or null when every group has a pick */
  function pickerGap() {
    var sel = document.querySelector('variant-selects, variant-radios');
    if (!sel) return null;
    var names = {}, order = [];
    sel.querySelectorAll('input[type="radio"]').forEach(function (r) {
      if (!names[r.name]) { names[r.name] = []; order.push(r.name); }
      names[r.name].push(r);
    });
    for (var i = 0; i < order.length; i++) {
      if (!names[order[i]].some(function (r) { return r.checked; })) return { el: names[order[i]][0], word: optionWord(order[i]) };
    }
    var empty = Array.prototype.filter.call(sel.querySelectorAll('select'), function (s) { return !s.value; })[0];
    return empty ? { el: empty, word: optionWord(empty.name) } : null;
  }
  /* null = this page's product takes no part (not covered, no product form, or sold out in the picked size/colour);
     otherwise { id, price, was, now, off, gap, gapEl } with gap = the option still to pick ('' when picked) */
  function pageItem(part) {
    if (!part) return null;
    /* 10-08: a boot is not on the bundle, but it still shows as the first row and Add all still adds it (data-p-row="1"), at its own price, outside the Buy 2 / Buy 3 pool */
    var cov = part.getAttribute('data-p-cov') === '1';
    if (!cov && part.getAttribute('data-p-row') !== '1') return null;
    var price = Number(part.getAttribute('data-p-price')) || 0, was = Number(part.getAttribute('data-p-was')) || price;
    var item = { id: 0, price: price, was: was, now: price, off: '', gap: '', gapEl: null, cov: cov };
    var f = mainForm(), idEl = f && f.querySelector('[name="id"]');
    if (!idEl) return null;
    var gap = pickerGap(), id = Number(idEl.value) || 0;
    if (gap || !id) { item.gap = (gap && gap.word) || 'option'; item.gapEl = gap && gap.el; return item; }
    var atc = document.querySelector('.main-product-atc');
    if (atc && atc.disabled) return null;
    item.id = id;
    try {
      var js = document.querySelector('variant-selects script[type="application/json"], variant-radios script[type="application/json"]');
      JSON.parse(js.textContent).forEach(function (v) {
        if (v.id === id) { item.price = item.now = v.price; item.was = Math.max(v.compare_at_price || 0, v.price); }
      });
    } catch (err) { /* keep the numbers the page was rendered with */ }
    return item;
  }
  function chooseVariant(page) {
    var el = page.gapEl || document.querySelector('variant-selects, variant-radios');
    if (!el) return;
    var box = el.closest('variant-selects, variant-radios') || el;
    box.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
    try { el.focus({ preventScroll: true }); } catch (err) { /* hidden radios may refuse focus */ }
  }

  /* ---------- add-all total + label ---------- */
  /* 10-06 21:3x: the box shows what the cart charges. The live Buy 2 / Buy 3 deals cut only the CHEAPEST items (Buy 2: 1 item, Buy 3: 2 items),
     counting this page's product plus every ticked covered row. Ties cut the later-added item. Row prices, row pills and the Add all total all
     come from that one pass, so no row claims a cut it will not get. Without the numbers on the part (or without JS) rows show their plain price. */
  function applyCut(part, fmt) {
    var rows = [];
    document.querySelectorAll('[data-dnp-look]').forEach(function (b, i) {
      rows.push({ box: b, row: b.closest('.dnp-ctl'), on: b.checked, i: i + 1, cov: b.getAttribute('data-cov') === '1',
        price: Number(b.getAttribute('data-price')) || 0, now: Number(b.getAttribute('data-price')) || 0, off: '', free: false, bogo: b.getAttribute('data-bogo') || '' });
    });
    var page = part ? pageItem(part) : null;
    if (part) {
      var keep2 = Number(part.getAttribute('data-keep2')) || 0, keep3 = Number(part.getAttribute('data-keep3')) || 0;
      var pool = [];
      if (page && page.cov) pool.push({ page: true, price: page.price, i: 0 });
      rows.forEach(function (r) { if (r.on && r.cov) pool.push({ r: r, price: r.price, i: r.i }); });
      var cuts = 0, keep = 1, label = '';
      if (pool.length >= 3 && keep3) { cuts = 2; keep = keep3 / 100; label = part.getAttribute('data-off3'); }
      else if (pool.length === 2 && keep2) { cuts = 1; keep = keep2 / 100; label = part.getAttribute('data-off2'); }
      pool.sort(function (a, b) { return (a.price - b.price) || (b.i - a.i); });
      pool.slice(0, cuts).forEach(function (p) {
        if (p.page) { page.now = Math.round(page.price * keep); page.off = label; } else { p.r.now = Math.round(p.r.price * keep); p.r.off = label; }
      });
    }
    /* the two buy-one-get-one deals (Sunglasses, Charms): of every two ticked in the same group the cheaper one is free; ties free the later-added */
    var groups = {};
    rows.forEach(function (r) { if (r.on && r.bogo) (groups[r.bogo] = groups[r.bogo] || []).push(r); });
    Object.keys(groups).forEach(function (k) {
      var g = groups[k].sort(function (a, b) { return (a.price - b.price) || (b.i - a.i); });
      g.slice(0, Math.floor(g.length / 2)).forEach(function (r) { r.now = 0; r.free = true; });
    });
    rows.forEach(function (r) {
      var b = r.row && r.row.querySelector('[data-dnp-now]');
      if (b) b.textContent = r.free ? 'Free' : money(r.now, fmt);
      var pill = r.row && r.row.querySelector('[data-dnp-pill]');
      if (pill) {
        /* 10-07: a covered row with no tier cut shows its normal discount (data-plain, e.g. "50% off") in a muted pill, on every page */
        var plain = r.off ? '' : (pill.getAttribute('data-plain') || '');
        pill.textContent = r.off || plain; pill.hidden = !(r.off || plain);
        pill.classList.toggle('dnp-ctl__off--plain', !!plain);
      }
    });
    /* 10-07 (Q3): this page's own product is the first row of the box. It shows the same numbers the cart will charge: the tier cut when it is one of
       the cheapest items, else its normal discount in the muted pill. The row hides when the page item takes no part (sold out in the picked variant). */
    var prow = document.querySelector('[data-dnp-page-row]');
    if (prow) {
      prow.hidden = !page;
      if (page) {
        var pn = prow.querySelector('[data-dnp-page-now]'), pw = prow.querySelector('[data-dnp-page-was]'), pp = prow.querySelector('[data-dnp-page-pill]');
        if (pn) pn.textContent = money(page.now, fmt);
        if (pw) { pw.textContent = money(page.was, fmt); pw.hidden = page.was <= page.now; }
        var pplain = (!page.off && page.was > page.price) ? Math.round((page.was - page.price) * 100 / page.was) + '% off' : '';
        if (pp) { pp.textContent = page.off || pplain; pp.hidden = !(page.off || pplain); pp.classList.toggle('dnp-ctl__off--plain', !!pplain); }
      }
    }
    rows.page = page;
    return rows;
  }

  function updateTotal() {
    var btn = document.querySelector('[data-dnp-add-all]');
    if (!btn) return;
    var fmt = btn.getAttribute('data-money-format');
    var now = 0, was = 0, n = 0, ticked = 0;
    var rows = applyCut(document.querySelector('[data-dnp-look-part]'), fmt), page = rows.page;
    rows.forEach(function (r) {
      if (!r.on) return;
      ticked += 1;
      now += r.now;
      was += Number(r.box.getAttribute('data-was')) || 0;
    });
    n = ticked;
    /* 10-07: Add all also adds this page's own product, so its price and count are part of the button */
    var withPage = !!page && ticked > 0;
    if (withPage) { now += page.now; was += page.was; n += 1; }
    var gap = withPage ? page.gap : '';
    var t = btn.querySelector('[data-dnp-total]');
    var w = btn.querySelector('[data-dnp-total-was]');
    var l = btn.querySelector('[data-dnp-all-label]');
    if (t) t.textContent = money(now, fmt);
    if (w) { w.textContent = money(was, fmt); w.hidden = was <= now; }
    /* 10-07: "Save $X" chip in the button = struck compare-at total minus the Add all price */
    var sv = btn.querySelector('[data-dnp-save]');
    if (sv) { var amt = sv.querySelector('[data-dnp-save-amt]'); if (amt) amt.textContent = money(was - now, fmt); sv.hidden = was - now <= 0 || ticked === 0; }
    if (l) l.textContent = ticked === 0 ? 'Choose items' : (gap ? 'Choose ' + (/^[aeiou]/.test(gap) ? 'an ' : 'a ') + gap : (n === 1 ? 'Add 1 to cart' : 'Add all ' + n));
    if (gap) btn.setAttribute('data-gap', gap); else btn.removeAttribute('data-gap');
    btn.disabled = ticked === 0;
  }
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches) return;
    if (t.matches('[data-dnp-look]')) { updateTotal(); return; }
    /* a size/colour pick (or the theme writing the new variant id) changes the page item's price and whether Add all can add it */
    if (t.matches('variant-selects input, variant-selects select, variant-radios input, variant-radios select') || (t.name === 'id' && t.closest && t.closest('form[action*="/cart/add"]'))) {
      updateTotal(); setTimeout(updateTotal, 500);
    }
  });

  /* ---------- Add button: "Add to cart" for one, "Add 3 to cart" for more (no price on the button, his 10-05 call) ---------- */
  var atcOrig = null;
  function syncAtcLabel() {
    var btn = document.querySelector('.main-product-atc');
    var qty = document.querySelector('.product-form__quantity .quantity__input, quantity-input .quantity__input');
    if (!btn || !qty) return;
    var txt = btn.querySelector('.main-atc__label__text');
    var price = btn.querySelector('.main-atc-price');
    if (!txt || btn.disabled) return;
    var q = parseInt(qty.value, 10) || 1;
    if (q > 1) {
      if (atcOrig === null) atcOrig = txt.textContent.trim();
      txt.textContent = 'Add ' + q + ' to cart';
      if (price) price.style.display = 'none';
    } else {
      if (atcOrig !== null) { txt.textContent = atcOrig; atcOrig = null; }
      if (price) price.style.display = '';
    }
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('.quantity__button')) setTimeout(syncAtcLabel, 30);
  });
  document.addEventListener('change', function (e) {
    if (e.target.matches && e.target.matches('.quantity__input')) syncAtcLabel();
  });

  /* ---------- tidy the Add button price ($75.00 -> $75) and keep the stock line honest ---------- */
  function tidyPrice(root) {
    (root || document).querySelectorAll('[class*="main-atc-price-span"]').forEach(function (s) {
      var t = s.textContent;
      if (/\.00(?!\d)/.test(t)) s.textContent = t.replace(/\.00(?!\d)/, '');
    });
  }
  function syncStock() {
    var stock = document.querySelector('[data-dnp-stock]');
    var btn = document.querySelector('.main-product-atc');
    if (!stock || !btn) return;
    var out = btn.hasAttribute('disabled') || btn.getAttribute('data-unavailable') === 'true';
    var span = stock.querySelector('span');
    var want = out ? 'Sold out' : 'In stock, ready to ship';
    if (span && span.textContent !== want) span.textContent = want;
    stock.setAttribute('data-available', out ? 'false' : 'true');
  }
  function watchBuyBox() {
    var btn = document.querySelector('.main-product-atc');
    if (!btn) return;
    tidyPrice(btn);
    syncStock();
    var busy = false;
    var mo = new MutationObserver(function () {
      if (busy) return;
      busy = true;
      tidyPrice(btn);
      syncStock();
      /* 10-07 (Q13): the theme disables this button while a colour or size loads and re-enables it a moment later. The box used to recalculate only on the pick
         itself (and once 500 ms later), so it caught the button mid-load and showed "Add all 2" with the page row hidden for good. It now recalculates
         whenever the button changes state. updateTotal never writes to this button, so there is no loop. */
      updateTotal();
      busy = false;
    });
    mo.observe(btn, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'data-unavailable'] });
  }

  /* ---------- customer clip modal ---------- */
  var lastFocus = null;
  function openClip(src, opener) {
    if (!src) return;
    lastFocus = opener || document.activeElement;
    var m = document.createElement('div');
    m.className = 'dnp-clip-modal';
    m.setAttribute('role', 'dialog');
    m.setAttribute('aria-modal', 'true');
    m.setAttribute('aria-label', 'Customer clip');
    var v = document.createElement('video');
    v.src = src; v.controls = true; v.autoplay = true; v.playsInline = true; v.setAttribute('playsinline', '');
    var x = document.createElement('button');
    x.type = 'button'; x.setAttribute('aria-label', 'Close'); x.textContent = '×';
    m.appendChild(v); m.appendChild(x);
    function close() {
      document.removeEventListener('keydown', onKey);
      m.remove();
      document.documentElement.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    function onKey(e) { if (e.key === 'Escape') close(); }
    m.addEventListener('click', function (e) { if (e.target === m || e.target === x) close(); });
    document.addEventListener('keydown', onKey);
    document.documentElement.style.overflow = 'hidden';
    document.body.appendChild(m);
    x.focus();
  }

  /* ---------- smooth accordions (native <details>, so it still works without JS) ---------- */
  document.addEventListener('click', function (e) {
    var sum = e.target.closest('.dnp-acc summary, .dnp-faq summary');
    if (!sum) return;
    var d = sum.parentElement;
    var body = sum.nextElementSibling;
    if (!body || reduce || !body.animate) return;
    e.preventDefault();
    if (d.open) {
      d.classList.add('closing');
      var h = body.offsetHeight;
      body.style.overflow = 'hidden';
      var a = body.animate([{ height: h + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], { duration: 220, easing: 'cubic-bezier(.16,1,.3,1)' });
      a.onfinish = function () { d.open = false; d.classList.remove('closing'); body.style.overflow = ''; };
    } else {
      d.open = true;
      var h2 = body.offsetHeight;
      body.style.overflow = 'hidden';
      var b = body.animate([{ height: '0px', opacity: 0 }, { height: h2 + 'px', opacity: 1 }], { duration: 260, easing: 'cubic-bezier(.16,1,.3,1)' });
      b.onfinish = function () { body.style.overflow = ''; };
    }
  });

  /* ---------- related row: arrows in the heading step through the swipe row (the row loads after the page) ---------- */
  function relatedArrows() {
    var wrap = document.querySelector('[data-dnp-arrows]');
    var host = document.querySelector('product-recommendations');
    if (!wrap || !host) return;
    var prev = wrap.querySelector('[data-prev]'), next = wrap.querySelector('[data-next]');
    var track = null;
    function upd() {
      if (!track) return;
      var max = track.scrollWidth - track.clientWidth, x = track.scrollLeft;
      wrap.hidden = max <= 2;
      prev.disabled = x <= 2;
      next.disabled = x >= max - 2;
    }
    function step(d) { track.scrollBy({ left: d * track.clientWidth * 0.85, behavior: reduce ? 'auto' : 'smooth' }); }
    prev.addEventListener('click', function () { if (track) step(-1); });
    next.addEventListener('click', function () { if (track) step(1); });
    function find() {
      var t = host.querySelector('.product-grid');
      if (!t || t === track) return;
      track = t;
      if (window.dnAuto) window.dnAuto(track);
      track.addEventListener('scroll', upd, { passive: true });
      if ('ResizeObserver' in window) new ResizeObserver(upd).observe(track);
      upd();
    }
    window.addEventListener('resize', upd);
    if ('MutationObserver' in window) new MutationObserver(find).observe(host, { childList: true, subtree: true });
    find();
  }

  function init() { updateTotal(); watchBuyBox(); relatedArrows(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  /* ---------- community clips (10-06d, his ask): one sideways row; a tap plays the clip inside its tile with sound,
     tap again to pause; a round button mutes / unmutes; only one clip plays at a time; a clip pauses when scrolled away.
     The video file loads only on the first tap. ---------- */
  document.querySelectorAll('.dnp-ugc').forEach(function (sec) {
    var track = sec.querySelector('.dnp-vids');
    var tiles = [].slice.call(sec.querySelectorAll('.dnp-vid'));
    if (!track || !tiles.length) return;
    function stopOthers(keep) {
      tiles.forEach(function (t) { if (t !== keep && t._v && !t._v.paused) t._v.pause(); });
    }
    function setSnd(t) {
      var b = t.querySelector('.dnp-vid__snd');
      if (!b || !t._v) return;
      b.hidden = false;
      b.setAttribute('aria-pressed', t._v.muted ? 'false' : 'true');
      b.setAttribute('aria-label', t._v.muted ? 'Unmute' : 'Mute');
      t.classList.toggle('is-muted', t._v.muted);
    }
    tiles.forEach(function (t, i) {
      var hit = t.querySelector('.dnp-vid__hit'), snd = t.querySelector('.dnp-vid__snd');
      function ensure() {
        if (t._v) return t._v;
        var v = document.createElement('video');
        v.src = t.getAttribute('data-dnp-clip');
        v.playsInline = true; v.setAttribute('playsinline', ''); v.loop = true; v.preload = 'auto';
        v.setAttribute('disablepictureinpicture', '');
        var img = t.querySelector('img');
        if (img) v.poster = img.currentSrc || img.src;
        t.insertBefore(v, hit);
        v.addEventListener('play', function () { stopOthers(t); t.classList.add('is-playing'); hit.setAttribute('aria-label', 'Pause customer clip ' + (i + 1)); setSnd(t); });
        v.addEventListener('pause', function () { t.classList.remove('is-playing'); hit.setAttribute('aria-label', 'Play customer clip ' + (i + 1)); });
        v.addEventListener('volumechange', function () { setSnd(t); });
        t._v = v;
        return v;
      }
      hit.addEventListener('click', function () {
        var v = ensure();
        if (v.paused) {
          v.muted = t.getAttribute('data-muted') === '1';
          var pr = v.play();
          if (pr && pr.catch) pr.catch(function () { v.muted = true; v.play().catch(function () {}); });
        } else { v.pause(); }
      });
      snd.addEventListener('click', function () {
        if (!t._v) return;
        t._v.muted = !t._v.muted;
        t.setAttribute('data-muted', t._v.muted ? '1' : '0');
      });
    });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (!e.isIntersecting && e.target._v) e.target._v.pause(); });
      }, { threshold: 0.35 });
      tiles.forEach(function (t) { io.observe(t); });
    }
    /* arrows: shown only when the row is wider than its box */
    var nav = sec.querySelector('[data-ugc-nav]');
    if (!nav) return;
    var prev = nav.querySelector('[data-ugc-prev]'), next = nav.querySelector('[data-ugc-next]');
    function step() { var t = tiles[0]; return t ? (t.getBoundingClientRect().width + 14) * Math.max(1, Math.floor(track.clientWidth / (t.getBoundingClientRect().width + 14)) - 1 || 1) : track.clientWidth * 0.8; }
    function sync() {
      var over = track.scrollWidth > track.clientWidth + 4;
      nav.hidden = !over;
      prev.disabled = track.scrollLeft < 4;
      next.disabled = track.scrollLeft + track.clientWidth > track.scrollWidth - 4;
    }
    prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  });

})();

/* dn-guard: this file ran to the end (guards spec G1) */
(window.__dnLoaded = window.__dnLoaded || {}).pdp = true;
